import { gql } from '@apollo/client';

export const UPDATE_SELECTED_BUSINESS_FUNCTIONS = gql`
  mutation SetSelectedBusinessFunctions($data: [String!]!) {
    setSelectedBusinessFunctions(data: $data)
  }
`;

export const GET_BUSINESS_FUNCTIONS_DASHBOARD = gql`
  query GetBusinessFunctionsDashboard {
    getBusinessFunctionsDashboard {
      applicationsTagged
      lastUpdated
      isDirty
      name
      supportedByITApplication
      uuid
    }
  }
`;
